// these are reasons that we don't want to show to the user in the UI
// If there are anymore reasons that don't need to be shown, they can easily be added here
// Call toLowerCase after each string, to keep from case typo's being the reason why they show up
export const excludedDisconnectReasons = [
  'Disconnect for Nonpayment'.toLowerCase(),
  'Disconnect for Transfer of Billing'.toLowerCase(),
  'Disconnect for MAC'.toLowerCase(),
  'Disconnect for Vendor Decommission'.toLowerCase(),
];
